<template>
  <div>
    <div class="my-5">
      <h2 v-if="title">{{ title }}</h2>
      <v-simple-table :id="id" outlined class="mt-5 fields-table">
        <thead class="td-bg--grey">
          <tr>
            <th class="text-left subtitle-2 text--primary">
              {{ subTitle }}
            </th>
            <th class="text-right subtitle-2 text--primary">
              {{ fieldHeading }}
            </th>
          </tr>
        </thead>
        <tbody>
          <template v-if="hasFields">
            <tr v-for="{ field, text } in fields" :key="field">
              <td
                v-text="field"
                :colspan="!text ? 2 : 0"
                class="text-left"
                :class="
                  !text
                    ? 'text--secondary td-bg--grey subtitle-2'
                    : 'text--primary body-2'
                "
              />
              <td
                v-if="text"
                class="text-right subtitle-2 text--primary body-2"
                v-text="text"
              />
            </tr>
          </template>
        </tbody>
      </v-simple-table>
    </div>
  </div>
</template>

<script>
/**
 * Integrations maropost fields renderer
 */
export default {
  name: "IntegrationMappingFields",
  /**
  |--------------------------------------------------
  | Props
  |--------------------------------------------------
  */
  props: {
    id: { type: String, default: "fields-table", required: true },
    fields: { type: Array, default: () => [], required: true },
    title: { type: String, default: "" },
    subTitle: { type: String, default: "Maropost Fields", required: true },
    fieldHeading: { type: String, required: true }
  },
  /**
  |--------------------------------------------------
  | Computed Properties
  |--------------------------------------------------
  */
  computed: {
    hasFields() {
      return this.fields && this.fields.length > 0;
    }
  }
};
</script>

<style lang="scss" scoped>
.td-bg--grey {
  background-color: #f2f2f2;
}
.fields-table {
  border: 1px solid rgba(0, 0, 0, 0.08);
  box-sizing: border-box;
  border-radius: 4px;
}
</style>
